<template>
    <i
        class="fa fa-lg pointer"
        :class="'fa-' + icon"
        @click="sendReminder"
        :title="uLang('app.mark_invoice_as_paid', {invoice: this.lang(`app.${this.invoiceType}_invoice`)})"
    ></i>
</template>

<script>
import { ConfirmationAlert } from '~/Swals'

export default {
    name: 'SalesInvoiceReminderButton',

    props: {
        icon: {
            type: String,
            required: false,
            default: 'check',
        },
        invoiceType: {
            type: String,
            required: false,
            default: 'sales',
        },
        invoiceId: {
            type: Number,
            required: false,
        },
    },

    methods: {
        sendReminder() {
            new ConfirmationAlert({
                text: this.uLang('app.mark_invoice_as_paid', { invoice: this.lang(`app.${this.invoiceType}_invoice`) }),
            }).show().then(async () => {
                const response = await window.axios.post(route(`invoices.${this.invoiceType}.paid`, { invoice: this.invoiceId }));

                if(response.status === 200) {
                    return this.$snotify.info(this.uLang('app.invoice_marked_as_paid', { invoice: this.lang(`app.${this.invoiceType}_invoice`) }));
                }

                return this.$snotify.info(this.uLang('app.error'), this.uLang('app.try_again_later'));
            })
        }
    }
}
</script>

<style>

</style>